<div
  style="height: 100vh;background-image: url('./../../../../assets/body.jpg');background-repeat: no-repeat;background-size: 100% 100%;">
</div>
